"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackButton = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
const BackButtonRoot = (0, _material.styled)(_IconButton.default)(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  margin: theme.spacing(2)
}));
const BackButton = ({
  ariaLabel,
  className,
  handleClick,
  variant,
  color,
  size
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(BackButtonRoot, {
  variant: variant,
  color: color,
  size: size,
  className: className,
  "aria-label": ariaLabel,
  onClick: handleClick,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowLeftThin, {
    color: "inherit",
    fontSize: "inherit"
  })
});
exports.BackButton = BackButton;
